export default {
    getCloudinaryImageUrl(imageUrl) {
        return 'https://res.cloudinary.com/carfinance247-secure/image/fetch/w_750/' + imageUrl;
    }
}